import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Ellipse,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Ellipse, { cx: "12", cy: "5", rx: "9", ry: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 5V19A9 3 0 0 0 21 19V5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12A9 3 0 0 0 21 12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Database";
const Database = memo(themed(Icon));
export {
  Database
};
//# sourceMappingURL=database.js.map
